<div class="section">
    <div class="plot-dropdown" #dropdownRoot>
        <label class="plot-dropdown-label">RCN Plots</label>
        <button
            type="button"
            class="plot-dropdown-trigger"
            [class.open]="dropdownOpen"
            [disabled]="!plotOptions.length"
            (click)="toggleDropdown($event)"
            [attr.aria-expanded]="dropdownOpen"
            aria-haspopup="listbox"
        >
            <span class="plot-dropdown-trigger-label">{{ selectionLabel }}</span>
            <cds-icon shape="angle" [direction]="dropdownOpen ? 'up' : 'down'"></cds-icon>
        </button>
        <div *ngIf="dropdownOpen" class="plot-dropdown-panel" role="listbox">
            <ul class="plot-checkboxes">
                <li *ngFor="let plot of plotOptions">
                    <cds-checkbox>
                        <label>{{ plot.name }}</label>
                        <input
                            type="checkbox"
                            [checked]="isSelected(plot.name)"
                            (change)="togglePlot(plot)"
                        />
                    </cds-checkbox>
                </li>
            </ul>
        </div>
    </div>
    <button class="wiki-btn" (click)="goToWiki()">?</button>
</div>
<div class="data-container">
    <span *ngIf="!selectedResults.length">
        {{
            plotOptions.length
                ? 'Select one or more RCN plots to view'
                : 'Run the Recurrent neighborhood job to view data'
        }}
    </span>
    <app-recurrent-neighborhoods-result-content
        *ngFor="let rcn of selectedResults"
        [rcnEntry]="rcn"
    ></app-recurrent-neighborhoods-result-content>
</div>
